import { Expose, Transform, plainToClass } from 'class-transformer';

import { ExposeFunction, ExposeRawData } from '@lib/common/decorators';
import { SnRoute } from '@lib/state/router';
import { SnAvatar } from '@lib/ui/avatar';
import { SnBadge } from '@lib/ui/badge';
import { SnIcon } from '@lib/ui/icon';
import { SnMenu } from '@lib/ui/menu';
import { SnTooltip } from '@lib/ui/tooltip';

import {
  SnListItemConfig,
  SnListItemClickHandler,
  SnListItemHideExpression,
  SnListItemDisableExpression,
} from '../types';

export class SnListItem<D = any> {
  @Expose()
  public readonly label: string;

  @Expose()
  public readonly secondaryLabel: string;

  @Expose()
  @Transform((value, data) => SnIcon.fromConfig(data.icon))
  public readonly icon: SnIcon;

  @Expose()
  @Transform((value, data) => SnBadge.fromConfig(data.badge))
  public readonly badge: SnBadge;

  @Expose()
  @Transform((value, data) => SnRoute.fromConfig(data.route))
  public readonly route: SnRoute;

  @Expose()
  @Transform((value, data) => SnAvatar.fromConfig(data.avatar))
  public readonly avatar: SnAvatar;

  @Expose()
  @Transform((value, data) => SnTooltip.fromConfig(data.tooltip))
  public readonly tooltip: SnTooltip;

  @Expose()
  @Transform((value, data) => SnMenu.fromConfig(data.menu))
  public readonly menu: SnMenu;

  @ExposeFunction()
  public readonly click: SnListItemClickHandler;

  @ExposeFunction()
  public readonly hidden: SnListItemHideExpression;

  @ExposeFunction()
  public readonly disabled: SnListItemDisableExpression;

  @ExposeRawData()
  public readonly data: D;

  public static fromConfig(config: SnListItemConfig): SnListItem {
    const data = typeof config === 'string' ? { label: config } : config;

    return plainToClass(SnListItem, data, { strategy: 'excludeAll' });
  }

  constructor() {}
}
